/**
 * Function to safely parse json in a try catch
 * returns undefined in case the string is invalid
 * @param str json string to be parsed
 * @returns
 */
const safeJsonParse = <T>(str: string) => {
  try {
    const jsonValue: T = JSON.parse(str);
    return jsonValue;
  } catch {
    return undefined;
  }
};

export default safeJsonParse;
